import script from "./OkrLevelsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrLevelsStep.vue?vue&type=script&setup=true&lang=js"

import "./OkrLevelsStep.vue?vue&type=style&index=0&id=1d932f27&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d932f27"]])

export default __exports__